// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#reservation-schedule-template-list[data-v-2456cf61]{max-width:740px;margin-left:auto;margin-right:auto}#reservation-schedule-template-list .box-header[data-v-2456cf61]{width:100%}#reservation-schedule-template-list .box-header .title[data-v-2456cf61]{font-size:22px;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
